module.exports = __webpack_public_path__ + "img/pdf_medicine_bio.2f4a4fc6.jpg";